import { memo } from 'react'
import './index.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import { useReports } from '../../../hooks/useReports'

const ReportNavbar = memo(() => {
  const navigate = useNavigate()
  const location = useLocation()

  const { reports } = useReports()

  return (
    <div className="ReportNavbar">
      {Object.keys(reports)
        .map((id: string) => {
          const { name, url } = reports[id]
          const reportUrl = `/reports${url}`
          const isSelected = reportUrl === location.pathname
          return (
            <div
              className={`ReportNavbar__report${isSelected ? ' selected' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => navigate(reportUrl)}
            >
              {name}
            </div>
          )
        })}
    </div>
  )
})

export default ReportNavbar
